// src/lib/api.js
// Helper para chamadas API autenticadas
// Automaticamente inclui o token JWT do Supabase em todas as requests

import { supabase } from './supabase';

/**
 * Faz uma request autenticada para a API.
 * Automaticamente inclui o Bearer token do Supabase.
 *
 * Uso:
 *   import { apiFetch } from '../lib/api';
 *   const data = await apiFetch('/api/orcamento/criar', { method: 'POST', body: {...} });
 */
export async function apiFetch(url, options = {}) {
  // Pegar o token JWT atual do Supabase
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
    body: options.body ? (typeof options.body === 'string' ? options.body : JSON.stringify(options.body)) : undefined,
  });

  // Se 401, o token expirou — tentar refresh
  if (response.status === 401 && token) {
    const { data: { session: newSession } } = await supabase.auth.refreshSession();
    if (newSession?.access_token) {
      headers['Authorization'] = `Bearer ${newSession.access_token}`;
      const retryResponse = await fetch(url, {
        ...options,
        headers,
        body: options.body ? (typeof options.body === 'string' ? options.body : JSON.stringify(options.body)) : undefined,
      });
      return retryResponse;
    }
  }

  return response;
}

/**
 * Shorthand para POST autenticado
 */
export async function apiPost(url, body) {
  return apiFetch(url, { method: 'POST', body });
}

/**
 * Shorthand para GET autenticado
 */
export async function apiGet(url) {
  return apiFetch(url, { method: 'GET' });
}
